
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { InjectFunction } from "@common/src/utils/decorator";
const store = namespace("store");
const common_base = namespace("common_base");

@InjectFunction("dayjs", "emptyToLine")
@Component({})
export default class CouponPreview extends Vue {
  @store.State storeData;
  @Prop({ default: () => {}, type: Object })
  couponInfo: any;
  @Prop({ default: false, type: Boolean })
  active: boolean;
  @common_base.State currencyUnit;

  get timeStr() {
    if (this.couponInfo.time && this.couponInfo.time.length > 0) {
      return `${this.dayjs(this.couponInfo.time[0]).format("YYYY.MM.DD HH:mm:ss")} -
            ${this.dayjs(this.couponInfo.time[1]).format("YYYY.MM.DD HH:mm:ss")} `;
    } else if (this.couponInfo.activityBegin && this.couponInfo.activityEnd) {
      return `${this.dayjs(this.couponInfo.activityBegin).format("YYYY.MM.DD HH:mm:ss")} -
            ${this.dayjs(this.couponInfo.activityEnd).format("YYYY.MM.DD HH:mm:ss")} `;
    } else {
      return "";
    }
  }
  discountRateFormat(value) {
    if (!value) return "";
    return (100 - value * 100).toFixed(0);
  }
}
